/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { discountsDelete } from "../../funcs/discountsDelete.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string(),
};

export const tool$discountsDelete: ToolDefinition<typeof args> = {
  name: "discounts-delete",
  description: `Delete a discount.

Permanently delete a discount code. Prevent further usage of the discount.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await discountsDelete(
      client,
      args.id,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
